import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        manualsPageContainer: {
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'background.default',
        },
        pageInnerContainer: {
            width: '100%',
            layerStyle: 'full-width',
            flexDirection: 'column',
            padding: {base: `0 ${remCalc(16)}`, xl: 'unset'},
        },
        breadcrumbContainer: {marginBottom: {base: remCalc(40), lg: remCalc(80)}},
        goBackButtonContainer: {marginBottom: 'medium.md'},
        goBackButton: {
            variant: 'text-button',
            textDecoration: 'unset',
        },
        headerContentContainer: {
            flexDirection: 'column',
            gap: 'medium.base',
            marginBottom: {base: 'large.base', lg: 'large.lg'},
        },
        manualsDivider: {color: 'background.grey'},
        headerTitle: {textStyle: 'head-medium', fontWeight: 'medium'},
        headerSubtitle: {
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
            my: 'small.base',
        },
        headerFindProductNumberLabel: {
            cursor: 'pointer',
            textStyle: 'body-xxsmall',
            fontWeight: 'normal',
            textDecoration: 'underline',
        },
        headerDivider: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
        },
        manualsModalContent: {
            width: '100%',
            maxW: remCalc(688),
        },
        modalInstructionsContainer: {
            flexDirection: 'column',
            textStyle: 'body-small',
            fontWeight: 'normal',
            gap: 'small.base',
            marginBottom: 'medium.base',
        },
        manualsModalBody: {
            padding: {
                base: `0 ${remCalc(24)} ${remCalc(80)}`,
                lg: `0 ${remCalc(24)} ${remCalc(40)}`,
            },
        },
        manualsModalHeader: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'small.base',
            padding: {
                base: `${remCalc(80)} ${remCalc(24)} ${remCalc(16)}`,
                lg: `${remCalc(40)} ${remCalc(24)} ${remCalc(16)}`,
            },
        },
        manualsModalTitle: {
            textStyle: 'body-large',
            fontWeight: 'normal',
            color: 'text.default',
        },
        noResultsText: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.tertiary',
        },
        searchContainer: {
            maxWidth: remCalc(570),
            flexDirection: 'column',
            gap: remCalc(20),
        },
        quicklinkContainer: {
            width: '100%',
            layerStyle: 'full-width',
            padding: {base: `0 ${remCalc(16)}`, xl: 'unset'},
        },
    },
}
